/* ==========================================================================
   SōH theme.js — vanilla JS, no framework, no build step.
   Handles: mobile menu, cart drawer (Shopify AJAX Cart API), collection
   sort toggle, product gallery + variant picker, Atelier configurator.
   ========================================================================== */
(function () {
  'use strict';

  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function cartEndpoint(path) {
    return shopRoot + path;
  }

  /* ---------------- Mobile menu ---------------- */
  var menuBtn = document.querySelector('[data-menu-open]');
  var menu = document.querySelector('[data-mobile-menu]');
  var menuClose = document.querySelector('[data-menu-close]');

  function openMobileMenu() {
    if (!menu) return;
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (menuClose) menuClose.focus();
  }
  function closeMobileMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    if (menuBtn) { menuBtn.setAttribute('aria-expanded', 'false'); menuBtn.focus(); }
    document.body.style.overflow = '';
  }
  if (menuBtn && menu) menuBtn.addEventListener('click', openMobileMenu);
  if (menuClose && menu) menuClose.addEventListener('click', closeMobileMenu);

  /* ---------------- Header search panel ---------------- */
  var searchBtn = document.querySelector('[data-search-open]');
  var searchPanel = document.querySelector('[data-header-search]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchInput = document.querySelector('[data-search-input]');
  function openSearch() {
    if (!searchPanel) return;
    searchPanel.removeAttribute('hidden');
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'true');
    if (searchInput) searchInput.focus();
  }
  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.setAttribute('hidden', 'hidden');
    if (searchBtn) { searchBtn.setAttribute('aria-expanded', 'false'); searchBtn.focus(); }
  }
  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  /* ---------------- Standalone quantity steppers (product page, not cart) ---------------- */
  document.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-qty-increase]');
    var decBtn = e.target.closest('[data-qty-decrease]');
    if (!incBtn && !decBtn) return;
    var stepper = (incBtn || decBtn).closest('.qty-stepper');
    if (!stepper) return;
    var input = stepper.querySelector('input[name="quantity"]');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    val = incBtn ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Cart drawer (Shopify AJAX Cart API) ---------------- */
  var cartScrim = document.querySelector('[data-cart-scrim]');
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartTriggers = document.querySelectorAll('[data-cart-open]');
  var cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartScrim) cartScrim.classList.add('is-open');
    cartTriggers.forEach(function (el) { el.setAttribute('aria-expanded', 'true'); });
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
    var closeBtn = cartDrawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartScrim) cartScrim.classList.remove('is-open');
    cartTriggers.forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
    document.body.style.overflow = '';
  }
  cartTriggers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });
  cartCloseBtns.forEach(function (el) { el.addEventListener('click', closeCartDrawer); });
  if (cartScrim) cartScrim.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCartDrawer();
    if (menu && menu.classList.contains('is-open')) closeMobileMenu();
    if (searchPanel && !searchPanel.hasAttribute('hidden')) closeSearch();
  });

  function fmtMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (format) return format.replace(/\{\{\s*amount\s*\}\}/, value);
    return '$' + value;
  }

  function renderCartDrawer(cart) {
    var itemsEl = document.querySelector('[data-cart-drawer-items]');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    if (!itemsEl) return;

    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item) {
        var isAtelier = item.properties && item.properties._type === 'atelier-deposit';
        var lineLabel = isAtelier
          ? (item.properties._commission_name || item.product_title)
          : item.product_title;
        var specMini = isAtelier
          ? '50% Atelier deposit due today'
          : (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
        return (
          '<div class="cart-line" data-line-key="' + item.key + '">' +
            '<div class="thumb">' + (item.image ? '<img src="' + item.image + '" alt="">' : 'Photo') + '</div>' +
            '<div>' +
              '<div class="name">' + lineLabel + '</div>' +
              (specMini ? '<div class="spec-mini">' + specMini + '</div>' : '') +
              (isAtelier ? '' :
                '<div class="qty-stepper">' +
                  '<button type="button" data-cart-qty-decrease>−</button>' +
                  '<span class="qty">' + item.quantity + '</span>' +
                  '<button type="button" data-cart-qty-increase>+</button>' +
                '</div>') +
              '<button type="button" class="remove" data-cart-remove>Remove</button>' +
            '</div>' +
            '<div class="price mono">' + fmtMoney(item.final_line_price) + '</div>' +
          '</div>'
        );
      }).join('');
    }
    if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.total_price);
  }

  function refreshCartDrawer() {
    fetch(cartEndpoint('cart.js'))
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () { /* silent — network unavailable */ });
  }

  document.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-cart-qty-increase]');
    var decBtn = e.target.closest('[data-cart-qty-decrease]');
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!incBtn && !decBtn && !removeBtn) return;
    var lineEl = e.target.closest('[data-line-key]');
    if (!lineEl) return;
    var key = lineEl.getAttribute('data-line-key');
    var qtyEl = lineEl.querySelector('.qty');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

    var newQty = qty;
    if (incBtn) newQty = qty + 1;
    if (decBtn) newQty = Math.max(0, qty - 1);
    if (removeBtn) newQty = 0;

    fetch(cartEndpoint('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  });

  // Any form with data-ajax-cart-add submits via AJAX and opens the drawer
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart-add]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = e.submitter || form.querySelector('[data-add-to-cart], [type="submit"]');
    if (!submitBtn && form.id) {
      submitBtn = document.querySelector('[type="submit"][form="' + form.id + '"]');
    }
    var errorEl = form.closest('[data-atelier-root]')
      ? form.closest('[data-atelier-root]').querySelector('[data-atelier-error]')
      : form.querySelector('[data-form-error]');
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
    var calculation = typeof form.atelierRecalculate === 'function' ? form.atelierRecalculate() : null;
    if (calculation && calculation.valid === false) return;
    // Guard against Enter-key submission bypassing a disabled Add to Cart
    // button (e.g. pressing Enter while focused in the quantity field) —
    // an unavailable variant must never reach /cart/add.js.
    if (submitBtn && submitBtn.hasAttribute('disabled')) return;

    var formData = new FormData(form);
    var submitLabel = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.textContent = 'Adding…';
    }

    fetch(cartEndpoint('cart/add.js'), { method: 'POST', body: formData })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (err) { throw err; }); }
        return r.json();
      })
      .then(function () {
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.textContent = submitLabel;
        }
        openCartDrawer();
      })
      .catch(function (err) {
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.textContent = submitLabel;
        }
        if (errorEl) {
          errorEl.textContent = (err && (err.description || err.message)) || 'This item could not be added. Check the deposit product setup and try again.';
          errorEl.hidden = false;
        }
      });
  });

  // Initial cart count on load
  document.addEventListener('DOMContentLoaded', function () {
    fetch(cartEndpoint('cart.js')).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    }).catch(function () {});
  });

  /* ---------------- Reduced motion: pause autoplay hero video ---------------- */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.hero-band video').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }

  /* ---------------- Collection sort toggle (client-side, DOM re-order) ----------------
     - First click on a key sorts ascending; clicking the same active key again reverses it.
     - Items missing the relevant data attribute (e.g. no weight set) always sort last,
       regardless of direction — never treated as zero.
     - Works independently across multiple grids on the same page (Home, Equipment,
       Atelier can each have their own sort toggle + grid). ---------------- */
  document.querySelectorAll('[data-sort-toggle]').forEach(function (group) {
    var buttons = group.querySelectorAll('button[data-sort-key]');
    var gridId = group.getAttribute('data-sort-target');
    var grid = gridId ? document.getElementById(gridId) : null;
    if (!grid) return;

    var state = { key: null, dir: 'asc' };

    function render() {
      buttons.forEach(function (b) {
        var arrow = b.querySelector('.sort-arrow');
        var isActive = b.getAttribute('data-sort-key') === state.key;
        b.classList.toggle('active', isActive);
        b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (arrow) arrow.textContent = isActive ? (state.dir === 'asc' ? ' ↑' : ' ↓') : '';
      });

      var items = Array.prototype.slice.call(grid.children);
      items.sort(function (a, b) {
        var aHas = a.hasAttribute('data-' + state.key);
        var bHas = b.hasAttribute('data-' + state.key);
        if (!aHas && !bHas) return 0;
        if (!aHas) return 1;   // missing value always sorts last, any direction
        if (!bHas) return -1;
        var av = parseFloat(a.getAttribute('data-' + state.key));
        var bv = parseFloat(b.getAttribute('data-' + state.key));
        var diff = av - bv;
        return state.dir === 'asc' ? diff : -diff;
      });
      items.forEach(function (item) { grid.appendChild(item); });
    }

    buttons.forEach(function (btn) {
      btn.setAttribute('aria-pressed', 'false');
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-sort-key');
        if (state.key === key) {
          state.dir = state.dir === 'asc' ? 'desc' : 'asc';
        } else {
          state.key = key;
          state.dir = 'asc';
        }
        render();
      });
    });
  });

  /* ---------------- Horizontal product sliders ---------------- */
  document.querySelectorAll('[data-product-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-product-slider-track]');
    var previous = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    if (!track) return;
    function move(direction) {
      track.scrollBy({ left: direction * Math.max(280, track.clientWidth * 0.82), behavior: 'smooth' });
    }
    if (previous) previous.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
  });

  /* ---------------- Product gallery ---------------- */
  document.querySelectorAll('[data-review-summary]').forEach(function (summary) {
    summary.addEventListener('click', function () {
      var reviews = document.querySelector('[data-product-reviews]');
      if (reviews) reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main-img] img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var src = thumb.getAttribute('data-full-src');
        var alt = thumb.getAttribute('data-image-alt');
        if (main && src) {
          main.src = src;
          if (alt !== null) main.alt = alt;
        }
      });
    });
  });

  /* ---------------- Variant picker ---------------- */
  document.querySelectorAll('[data-product-form]').forEach(function (formEl) {
    var dataScript = formEl.querySelector('[data-variant-json]');
    if (!dataScript) return;
    var variants;
    try { variants = JSON.parse(dataScript.textContent); } catch (err) { return; }

    var optionInputs = formEl.querySelectorAll('[data-option-selector] input[type="radio"], [data-option-selector] select');
    var priceEl = formEl.querySelector('[data-product-price]');
    var availabilityEl = formEl.querySelector('[data-product-availability]');
    var addBtn = formEl.querySelector('[data-add-to-cart]');
    var variantIdInput = formEl.querySelector('[data-variant-id-input]');
    var specEls = formEl.querySelectorAll('[data-spec-field]');

    function getSelectedOptions() {
      var selections = [];
      var groups = {};
      formEl.querySelectorAll('[data-option-selector]').forEach(function (group) {
        var idx = group.getAttribute('data-option-index');
        var checked = group.querySelector('input:checked, select');
        var val = checked ? checked.value : null;
        if (val) groups[idx] = val;
      });
      return groups;
    }

    function findMatchingVariant() {
      var groups = getSelectedOptions();
      return variants.find(function (v) {
        return Object.keys(groups).every(function (idx) {
          return v['option' + idx] === groups[idx];
        });
      });
    }

    function updateForVariant() {
      var variant = findMatchingVariant();
      if (!variant) {
        if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = fmtMoney(variant.price);
      if (availabilityEl) {
        availabilityEl.textContent = variant.available ? 'In stock' : 'Sold out';
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = addBtn.getAttribute('data-label-available') || 'Add to Cart →';
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = addBtn.getAttribute('data-label-soldout') || 'Sold Out';
        }
      }
      specEls.forEach(function (el) {
        var field = el.getAttribute('data-spec-field');
        var val = variant[field] || el.getAttribute('data-product-fallback');
        if (val) el.textContent = val;
      });
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateForVariant);
    });
    updateForVariant();
  });

  /* ---------------- Atelier configurator ---------------- */
  var configRoot = document.querySelector('[data-atelier-root]');
  var configForm = configRoot ? configRoot.querySelector('[data-atelier-config]') : null;
  if (configRoot && configForm) {
    var BASE = parseFloat(configForm.getAttribute('data-base-price') || '0');
    var DEPOSIT_RATE = parseFloat(configForm.getAttribute('data-deposit-rate') || '0.5');
    var DEPOSIT_UNIT_CENTS = parseInt(configForm.getAttribute('data-deposit-unit-cents') || '0', 10) || 0;
    var INCLUDED_LABEL = configRoot.getAttribute('data-included-label') || 'Included';
    var NONE_LABEL = configRoot.getAttribute('data-none-label') || 'None selected';
    var depositButton = configRoot.querySelector('[data-atelier-submit]');
    var depositError = configRoot.querySelector('[data-atelier-error]');

    function fmtDollars(value) {
      return '$' + Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function fmtAdded(value) {
      if (!value) return INCLUDED_LABEL;
      return '+$' + Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 });
    }

    function recalcAtelier() {
      var optionTotal = 0;

      configForm.querySelectorAll('[data-config-choice]').forEach(function (group) {
        var type = group.getAttribute('data-choice-type');
        var groupId = group.getAttribute('data-group-id');
        var groupPrice = 0;
        var selectedLabels = [];

        if (type === 'dropdown') {
          var select = group.querySelector('[data-config-select]');
          var selected = select && select.options.length ? select.options[select.selectedIndex] : null;
          if (selected) {
            groupPrice = parseFloat(selected.value) || 0;
            selectedLabels.push(selected.getAttribute('data-label') || selected.textContent.trim());
          }
        } else if (type === 'checkboxes') {
          group.querySelectorAll('[data-config-checkbox]:checked').forEach(function (checkbox) {
            groupPrice += parseFloat(checkbox.getAttribute('data-price')) || 0;
            selectedLabels.push(checkbox.getAttribute('data-label') || 'Selected option');
          });
        } else {
          var radio = group.querySelector('[data-config-radio]:checked');
          if (radio) {
            groupPrice = parseFloat(radio.value) || 0;
            selectedLabels.push(radio.getAttribute('data-label') || 'Selected option');
          }
        }

        optionTotal += groupPrice;

        var property = group.querySelector('[data-config-property]');
        if (property) property.value = selectedLabels.length ? selectedLabels.join(', ') : NONE_LABEL;

        var summary = configRoot.querySelector('[data-config-summary="' + groupId + '"]');
        if (summary) {
          summary.textContent = type === 'checkboxes'
            ? (selectedLabels.length ? selectedLabels.join(', ') : NONE_LABEL)
            : fmtAdded(groupPrice);
        }
      });

      var total = BASE + optionTotal;
      var depositCents = Math.round(total * DEPOSIT_RATE * 100);
      var depositQuantity = DEPOSIT_UNIT_CENTS > 0 ? Math.max(1, Math.round(depositCents / DEPOSIT_UNIT_CENTS)) : 0;
      var chargedDepositCents = depositQuantity * DEPOSIT_UNIT_CENTS;
      var chargedDeposit = chargedDepositCents / 100;
      var valid = total > 0 && DEPOSIT_UNIT_CENTS > 0 && chargedDepositCents === depositCents;

      setText('[data-sum-total]', fmtDollars(total));
      setText('[data-sum-deposit]', fmtDollars(depositCents / 100));
      setVal('[data-total-property]', fmtDollars(total));
      setVal('[data-deposit-property]', fmtDollars(depositCents / 100));
      setVal('[data-balance-property]', fmtDollars(total - (depositCents / 100)));

      var depositQtyInput = configForm.querySelector('[data-deposit-qty-input]');
      if (depositQtyInput) depositQtyInput.value = depositQuantity;

      if (depositButton) depositButton.disabled = !valid;
      if (depositError) {
        if (valid) {
          depositError.hidden = true;
          depositError.textContent = '';
        } else {
          depositError.hidden = false;
          depositError.textContent = total <= 0
            ? 'Set a base product price or select a priced option before paying the deposit.'
            : 'The selected deposit product cannot charge exactly 50% of this total. Set its single variant price to $0.50, make it available to the Online Store, and turn inventory tracking off.';
        }
      }

      return { total: total, deposit: chargedDeposit, valid: valid };
    }

    function setText(sel, text) {
      var el = configRoot.querySelector(sel);
      if (el) el.textContent = text;
    }
    function setVal(sel, val) {
      var el = configForm.querySelector(sel);
      if (el) el.value = val;
    }

    configForm.atelierRecalculate = recalcAtelier;
    configForm.addEventListener('change', recalcAtelier);
    configForm.addEventListener('input', recalcAtelier);
    recalcAtelier();

    // Slideshow
    var slides = configRoot.querySelectorAll('[data-slide]');
    var dotsWrap = configRoot.querySelector('[data-slide-dots]');
    var slideIndex = 0;
    if (slides.length && dotsWrap) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        if (i === 0) dot.classList.add('active');
        dot.type = 'button';
        dot.addEventListener('click', function () { goToSlide(i); });
        dotsWrap.appendChild(dot);
      });
    }
    function goToSlide(i) {
      if (!slides.length || !dotsWrap) return;
      slides[slideIndex].classList.remove('active');
      dotsWrap.children[slideIndex].classList.remove('active');
      slideIndex = i;
      slides[slideIndex].classList.add('active');
      dotsWrap.children[slideIndex].classList.add('active');
    }
    configRoot.querySelectorAll('[data-slide-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { goToSlide((slideIndex - 1 + slides.length) % slides.length); });
    });
    configRoot.querySelectorAll('[data-slide-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { goToSlide((slideIndex + 1) % slides.length); });
    });
  }
})();
